import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
interface GoogleOAuthSessionResponse {
  oauth_url: string;
}

// 主数据类
export class GoogleOAuthSessionData {
  @Required("OAuth URL cannot be empty")
  @IsString("OAuth URL must be a string")
  oauthUrl: string;
}

const transformAndValidateGoogleOAuthSession = (
  response: GoogleOAuthSessionResponse
): GoogleOAuthSessionData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, GoogleOAuthSessionData);
  } catch (error) {
    console.error("Google OAuth session data validation failed:", error.message);
    throw error;
  }
};

export const oauthGoogleSession = async (redirectUri: string, agentId?: string): Promise<GoogleOAuthSessionData> => {
  const res = await api.post<GoogleOAuthSessionResponse>("/oauth/google/session", {
    redirect_uri: redirectUri,
    agent_id: agentId
  });
  const validatedData = transformAndValidateGoogleOAuthSession(res.data);
  return validatedData;
};